export default "__VITE_ASSET__8WL_GGCP__"